const layers = {
  "WorldTopoMap":{
    exibition: "Topográfico",
    title: "ESRI-WorldTopoMap",
    visible: true,
    url:  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; <a class="secondary--text" href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>'
  },
  "WorldImagery":{
    exibition: "Satélite",
    title: "ESRI-WorldImagery",
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '<span class="secondary--text">Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community</span>'
  },
}
export default layers;
